import { Database, type LucideIcon, MessageCircle, Radar, Siren, Sparkles, Zap } from 'lucide-react';

import type { DependencyKind, DependencyStatus } from '@/schemas/commons';

import { styles } from './Dependencies.styles';

// One icon per backend dependency kind.
export const KIND_ICON: Record<DependencyKind, LucideIcon> = {
	redis: Zap,
	postgres: Database,
	qdrant: Radar,
	intercom: MessageCircle,
	llm: Sparkles,
	incidents_db: Siren,
};

// Status → translation key (under the `dependencies` keyPrefix).
export const STATUS_LABEL_KEY: Record<DependencyStatus, string> = {
	up: 'STATUS_UP',
	degraded: 'STATUS_DEGRADED',
	down: 'STATUS_DOWN',
	disabled: 'STATUS_DISABLED',
};

// Status → pill styling (container + dot), mirroring the Modules health pill.
export const STATUS_PILL: Record<DependencyStatus, { container: string; dot: string }> = {
	up: { container: styles.pillUp, dot: styles.dotSuccess },
	degraded: { container: styles.pillDegraded, dot: styles.dotWarn },
	down: { container: styles.pillDown, dot: styles.dotDown },
	disabled: { container: styles.pillMuted, dot: styles.dotMuted },
};

// Status → card frame. Degraded gets an amber border; disabled is muted.
export const CARD_CLASS: Record<DependencyStatus, string> = {
	up: styles.card,
	degraded: styles.cardDegraded,
	down: styles.card,
	disabled: styles.cardMuted,
};

// Meter fill color when the bar approaches its limit. Below WARN it stays
// the calm success green; past WARN it goes amber, past DANGER red.
export const METER_WARN_RATIO = 0.75;
export const METER_DANGER_RATIO = 0.9;
